var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowImg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 47,
    viewBox: "0 0 57 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_335_856",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 37,
    height: 47
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H46.3474V46.8681H10V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_335_856)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3021 33.654V23.3511C45.0153 22.6608 43.2529 22.094 41.1879 21.6499V12.9063C41.1879 5.82022 35.3214 0.0241699 28.1501 0.0241699C20.978 0.0241699 15.1116 5.82022 15.1116 12.9063V21.6499C13.0465 22.094 11.2842 22.6608 9.99805 23.3511V43.9546C17.181 47.8139 39.1185 47.8139 46.3021 43.9546V33.654ZM36.1163 20.8618C31.0613 20.3235 25.2367 20.3235 20.181 20.8618V12.9084C20.181 8.57868 23.7656 5.03494 28.1501 5.03494C32.5317 5.03494 36.1184 8.57653 36.1184 12.9084V20.8618H36.1163ZM22.6702 34.8055C22.0271 34.8055 21.5047 34.29 21.5047 33.654V26.5429C21.5047 25.9076 22.0271 25.3914 22.6702 25.3914H26.9846V24.1985C26.9846 23.5632 27.5063 23.0477 28.1501 23.0477C28.7932 23.0477 29.3156 23.5632 29.3156 24.1985V25.3914H33.6292C34.273 25.3914 34.7947 25.9076 34.7947 26.5429C34.7947 27.179 34.273 27.6944 33.6292 27.6944H29.3156V32.5025H33.6292C34.273 32.5025 34.7947 33.0186 34.7947 33.654V40.765C34.7947 41.4011 34.273 41.9165 33.6292 41.9165H29.3156V43.1072C29.3156 43.7426 28.7932 44.2587 28.1501 44.2587C27.5063 44.2587 26.9846 43.7426 26.9846 43.1072V41.9165H22.6702C22.0271 41.9165 21.5047 41.4011 21.5047 40.765C21.5047 40.1296 22.0271 39.6135 22.6702 39.6135H26.9846V34.8055H22.6702ZM26.9846 27.6944H23.8357V32.5025H26.9846V27.6944ZM29.3156 39.6135H32.4637V34.8055H29.3156V39.6135Z",
    fill: "#F8F8F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowImg4);
export default __webpack_public_path__ + "static/media/howImg4.c12dc936d9dea88286d86e9ab360b375.svg";
export { ForwardRef as ReactComponent };